<template>
  <div class="nativePAGE">
    <!-- <Title
      :datas="[{ text: '原生页', id: 123 }]"
      :active="123"
    /> -->
    <div class="nativePAGE_ButtonArea">
      <el-button
        type="primary"
        @click="isBounce = true"
      >创建原生页</el-button>
    </div>
    <div class="nativePAGE_list">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column
          prop="page_id"
          label="ID"
          width="180"
        />
        <el-table-column
          prop="canvas_name"
          label="名称"
          width="180"
        />
        <el-table-column
          prop="page_template_id"
          label="模版ID"
        />
        <el-table-column label="预览">
          <template slot-scope="scope">
            <div class="list_img">
              <img
                class="img"
                :src="scope.row.qrcode"
              >
              <div class="img_box">
                <img
                  class="img"
                  :src="scope.row.qrcode"
                >
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="operation">
              <div class="operation_item">
                <i class="el-icon-copy-document" />
                <span class="item_text">复制</span>
              </div>
              <div
                class="operation_item"
                @click="myDeleta(scope.row)"
              >
                <i class="el-icon-delete" />
                <span class="item_text">删除</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="nativePAGE_pagina">
      <el-pagination
        layout="prev, pager, next"
        :total="total"
        @current-change="currentChange"
      />
    </div>

    <div
      v-if="isBounce"
      class="Mantle"
    >
      <PopupList @close="isBounce = false" />
    </div>
  </div>
</template>

<script>
/* import Title from '@/components/Title/index.vue' */
import PopupList from './components/PopupList.vue'
import { getNative_accounts, deleteNative_accounts } from '@/api/nativePAGE.js'
import QRCode from 'qrcode'
export default {
  components: {
    /* Title, */
    PopupList
  },
  data() {
    return {
      total: null,
      tableData: [],
      loading: true,
      page: 1,
      isBounce: false
    }
  },
  created() {
    this.getList({ account_id: this.$route.query.account_id, page: this.page })
  },
  methods: {
    async getList(params = {}) {
      this.loading = true
      const data = await getNative_accounts(params)
      this.tableData = data.data.list
      this.total = data.data.count
      for (let i = 0; i < this.tableData.length; i++) {
        this.generateQRCode(this.tableData[i].preview_url, this.tableData[i])
      }
      this.loading = false
    },
    currentChange(currentPage) {
      this.page = currentPage
      this.getList({ account_id: this.$route.query.account_id, page: currentPage })
    },
    async generateQRCode(url, obj) {
      const myUrl = await QRCode.toDataURL(url)
      this.$set(obj, 'qrcode', myUrl)
    },
    async myDeleta(item) {
      this.loading = true
      await deleteNative_accounts(item.id, { account_id: this.$route.query.account_id, page_id: item.page_id })
      await this.getList({ account_id: this.$route.query.account_id, page: this.page })
      this.$message({
        message: '删除成功',
        type: 'success'
      })
    }
  }
}
</script>

<style lang="less">
.nativePAGE {
  width: 90%;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 30px;
  .nativePAGE_ButtonArea {
    height: 50px;
    display: flex;
    align-items: center;
    border: 1px solid #e6e8ed;
    /* border-top: none; */
    padding: 0px 20px;
  }
  .nativePAGE_list {
    border: 1px solid #dfe6ec;
    /* border-top: none; */
    border-bottom: none;
    div {
      overflow: inherit;
    }
    .list_img {
      width: 40px;
      height: 40px;
      cursor: pointer;
      position: relative;
      .img {
        width: 100%;
        height: 100%;
      }
      &:hover {
        .img_box {
          display: block;
        }
      }
      .img_box {
        position: absolute;
        width: 130px;
        height: 125px;
        border: 1px solid black;
        background-color: #fff;
        top: -40px;
        left: -131px;
        display: none;
        border-radius: 6px;
        padding: 5px;
        .img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .operation {
      display: flex;
      .operation_item {
        margin: 0px 6px;
        cursor: pointer;
        .item_text {
          display: inline-block;
          margin: 0px 5px;
        }
      }
    }
  }
  .nativePAGE_pagina {
    height: 40px;
    display: flex;
    align-items: center;
    border: 1px solid #dfe6ec;
    border-top: none;
    justify-content: flex-end;
  }
}

.Mantle {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  background-color: rgba(0, 0, 0, 0.65);
  z-index: 1111;
}
</style>
